import React from 'react';
import PropTypes from 'prop-types';
import * as Types from './types';
import BankNoticeV1 from './v1';
import BankNoticeV2 from './v2';
const VERSIONS = ['v1', 'v2'];
const BankNotice = ({
  cardIssuingBanks,
  publicSiteUrl,
  rewardProgramCode,
  programDefinitionCode,
  type,
  version = 'v1',
  withAutoRefinance = false,
  withDeposit = false,
  withNydigNotice
}) => {
  let BankNoticeComponent = BankNoticeV1;
  if (version === 'v2') {
    BankNoticeComponent = BankNoticeV2;
  }
  return /*#__PURE__*/React.createElement(BankNoticeComponent, {
    cardIssuingBanks,
    publicSiteUrl,
    type,
    withAutoRefinance,
    withDeposit,
    withNydigNotice,
    programDefinitionCode: programDefinitionCode || rewardProgramCode
  });
};
export default BankNotice;
BankNotice.propTypes = {
  publicSiteUrl: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(Types)).isRequired,
  withAutoRefinance: PropTypes.bool,
  withDeposit: PropTypes.bool,
  version: PropTypes.oneOf(VERSIONS)
};
//# sourceMappingURL=index.js.map